export enum SoccerPerformanceCategory {
	GoalsScoring = 'goals_scoring',
	MatchOutcome = 'match_outcome',
	CardsDiscipline = 'cards_discipline',
	SetPiecesPossessions = 'set_pieces_possessions',
}

export const SOCCER_PERFORMANCE_CATEGORY_LABELS: Record<SoccerPerformanceCategory, string> = {
	[SoccerPerformanceCategory.GoalsScoring]: 'Goals & Scoring',
	[SoccerPerformanceCategory.MatchOutcome]: 'Match Outcome',
	[SoccerPerformanceCategory.CardsDiscipline]: 'Cards & Discipline',
	[SoccerPerformanceCategory.SetPiecesPossessions]: 'Set Pieces & Possessions',
};
